import type { Department } from '../types/department'

export const ALL_DEPARTMENTS: Department[] = [
  {
    id: 1,
    name: 'Academic',
    description: 'Oversees all teaching, curriculum, and academic programs',
    code: 'ACAD',
    employees: 52,
    status: 'Active',
    createdDate: 'Jan 10, 2024',
    accentColor: '#3b82f6',
  },
  {
    id: 2,
    name: 'Administration',
    description: 'Handles day-to-day administrative operations, records, and staff management',
    code: 'ADMIN',
    employees: 12,
    status: 'Active',
    createdDate: 'Jan 10, 2024',
    accentColor: '#7c3aed',
  },
  {
    id: 3,
    name: 'Finance',
    description: 'Manages fee collection, payroll, budgeting, and all financial reporting',
    code: 'FIN',
    employees: 8,
    status: 'Active',
    createdDate: 'Jan 10, 2024',
    accentColor: '#16a34a',
  },
  {
    id: 4,
    name: 'Human Resources',
    description: 'Responsible for recruitment, onboarding, staff welfare, and HR policies',
    code: 'HR',
    employees: 5,
    status: 'Active',
    createdDate: 'Jan 15, 2024',
    accentColor: '#dc2626',
  },
  {
    id: 5,
    name: 'Information Technology',
    description: 'Manages school infrastructure, ERP systems, network, and tech support',
    code: 'IT',
    employees: 4,
    status: 'Active',
    createdDate: 'Feb 1, 2024',
    accentColor: '#ea580c',
  },
  {
    id: 6,
    name: 'Library',
    description: 'Manages the school library, catalog, book issuances, and research resources',
    code: 'LIB',
    employees: 3,
    status: 'Active',
    createdDate: 'Feb 10, 2024',
    accentColor: '#0891b2',
  },
  {
    id: 7,
    name: 'Management',
    description: 'Senior leadership team responsible for strategic direction and policy decisions',
    code: 'MGMT',
    employees: 4,
    status: 'Active',
    createdDate: 'Jan 1, 2024',
    accentColor: '#059669',
  },
  {
    id: 8,
    name: 'Sports & Physical Education',
    description: 'Oversees physical education curriculum, sports events, and fitness facilities',
    code: 'SPE',
    employees: 6,
    status: 'Inactive',
    createdDate: 'Mar 1, 2024',
    accentColor: '#92400e',
  },
  {
    id: 9,
    name: 'Science & Technology',
    description: 'Manages all science labs, research programs, and STEM curriculum execution',
    code: 'SCI',
    employees: 14,
    status: 'Active',
    createdDate: 'Jan 20, 2024',
    accentColor: '#7c3aed',
  },
]

export const PAGE_SIZE = 10

export const STATUS_OPTIONS = [
  { label: 'All Status', value: '' },
  { label: 'Active', value: 'Active' },
  { label: 'Inactive', value: 'Inactive' },
]
